import React from "react";
import { CardLayout } from "components/cardLayout";
import { companylogo } from "assets/images"
import "./DestinationCompanyDetailCard.scss"
import { getEstimatorDetails } from 'core/services/getEstimatorDetailsService'
import { getCustomerDetails } from "core/services/getCustomerDetailsService";
import moment from "moment";

export interface CompanyDetailCardProps {

}

export interface CompanyDetailCardState {
    customerDetails: any;
}

class ServiceDatesCard extends React.Component<CompanyDetailCardProps, CompanyDetailCardState> {
    private _isMounted: boolean = false;
    constructor(props: CompanyDetailCardProps) {
        super(props);
        this.state = {
            customerDetails: []
        };
    }

    async fetchData() {
        var CID = localStorage.getItem("CID") || "0";
        const securetoken :any= localStorage.getItem("securetoken")
        let response = await getCustomerDetails(CID,securetoken)
        this.setState({ customerDetails: response[0] })
        console.log("customer:" + JSON.stringify(this.state.customerDetails));
        
    }

    componentDidMount() {
        this._isMounted = true;
        this.fetchData();
    }
    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        const {customerDetails}=this.state;
        return (
            <CardLayout>

                <div className="movecustomer-detail">
                    <b>Service Dates</b>
                </div>
                <div className="address secondaryColor">
                   Agreed Service Dates
                </div>
                <div className="movecustomer-detail">
                    {/* <b>Address:</b> */}
                    {/* <h3>2400 Old Mill Rd. Carrollton, TX 75007</h3> */}
                    <h1>Pack:</h1>
                    <h3>{moment(customerDetails?.packDate).format("MM/DD/YY")}</h3>
                </div>
                <div className="movecustomer-detail">
                    <h1>Load:</h1>
                    {/* <h3>All My Sons Moving & Storage of Dallas, LLC</h3> */}
                    <h3>{moment(customerDetails?.loadDate).format("MM/DD/YY")}</h3>
                </div>
                <div className="movecustomer-detail">
                    <h1>Delivery:</h1>
                    {/* <h3>All My Sons Moving & Storage of Dallas, LLC</h3> */}
                    <h3>{customerDetails?.deliveryDate}</h3>
                </div>
            </CardLayout>
        );
    }
}

export default ServiceDatesCard;